import { createEntityAdapter, createSlice, isAsyncThunkAction } from '@reduxjs/toolkit';

import { fetchInGameHistoryData } from '../../../store/apiActions/fetchInGameHistoryData';

import { InGameHistoryState, InGameHistoryTypes } from './types';

const inGameHistoryAdaptor = createEntityAdapter<InGameHistoryTypes, number>({
  selectId: (data: InGameHistoryTypes) => data.uId,
  // sortComparer: (a: InGameHistoryTypes, b: InGameHistoryTypes) => b.placeBetTime.localeCompare(a.placeBetTime),
  sortComparer: (a: InGameHistoryTypes, b: InGameHistoryTypes) =>
    b.placeBetDate
      .concat(' ', b.placeBetTime, ' GMT')
      .localeCompare(a.placeBetDate.concat(' ', a.placeBetTime, ' GMT')),
});

export const inGameHistorySlice = createSlice({
  name: 'inGameHistory',
  initialState: inGameHistoryAdaptor.getInitialState({
    loading: true,
    loadMore: true,
    page: 1,
    error: false,
  } as InGameHistoryState),
  reducers: {
    setApiRejected: (state) => {
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInGameHistoryData.fulfilled, (state, action) => {
        if (action.payload.error === -1) {
          state.error = true;
        } else {
          inGameHistoryAdaptor.upsertMany(state, action);
          state.error = false;
          state.page = action.meta.arg.rowEnd / 20;
          state.loadMore = action.payload.length >= action.meta.arg.rowEnd;
        }
      })
      .addCase(fetchInGameHistoryData.rejected, (state) => {
        state.error = true;
        state.loading = false;
      })
      .addMatcher(isAsyncThunkAction(fetchInGameHistoryData), (state, action) => {
        state.loading = action.meta.requestStatus === 'pending';
      });
  },
});

export const inGameHistoryActions = inGameHistorySlice.actions;
